export default __webpack_public_path__ + "static/TemporaryImageEliteBuilder-3804791755fcd7eac47471c109b22e5f.jpg";